export default "__VITE_ASSET__Cm8aSE3$__"